export const Random = {
  int(min: number, max: number) {
    return Math.floor(Math.random() * max) + min;
  },
};
